import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "gfu-grid__cell gfu-1of1 gfu-6of12--m",
  "data-qa": "adyen-form:Name"
}
const _hoisted_2 = {
  class: "gfu-grid__cell gfu-1of1 gfu-6of12--m",
  "data-qa": "adyen-form:Email"
}
const _hoisted_3 = {
  class: "gfu-grid__cell gfu-1of1 gfu-6of12--m _fc",
  "data-qa": "adyen-form:CardNumber"
}
const _hoisted_4 = { class: "_pos-r" }
const _hoisted_5 = {
  class: "gfu-field__brands-container",
  "data-qa": "adyen-form:CardBrand"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "gfu-grid__cell gfu-1of1 gfu-6of12--m" }
const _hoisted_8 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_9 = { class: "gfu-grid__cell gfu-1of2 gfu-6of12--m" }
const _hoisted_10 = {
  class: "gfu-grid__cell gfu-1of2 gfu-6of12--m",
  "data-qa": "adyen-form:CvC"
}
const _hoisted_11 = {
  key: 0,
  class: "gfu-grid__cell gfu-1of1"
}
const _hoisted_12 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_13 = { class: "gfu-grid__cell gfu-1of1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_text_field = _resolveComponent("text-field")
  const _component_base_image = _resolveComponent("base-image")
  const _component_field = _resolveComponent("field")
  const _component_checkbox_field = _resolveComponent("checkbox-field")

  return (_openBlock(), _createElementBlock("fieldset", {
    class: _normalizeClass(['gfu-grid gfu-grid--gutter-columns', _ctx.$attrs.class])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_text_field, {
        modelValue: $data.holderName,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = $event => (($data.holderName) = $event)),
          $options.onFormDetailsChange
        ],
        class: "_mt-0",
        name: "holderName",
        "display-name": _ctx.Resources.Checkout.CheckoutCreditCardCardholderNameLabel
      }, null, 8 /* PROPS */, ["modelValue", "display-name", "onUpdate:modelValue"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_text_field, {
        modelValue: $data.email,
        "onUpdate:modelValue": [
          _cache[1] || (_cache[1] = $event => (($data.email) = $event)),
          $options.onFormDetailsChange
        ],
        class: "_mt-0",
        name: "email",
        "display-name": _ctx.Resources.Checkout.CheckoutCreditCardCardholderEmailLabel
      }, null, 8 /* PROPS */, ["modelValue", "display-name", "onUpdate:modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_field, {
        "display-name": _ctx.Resources.Checkout.CheckoutCreditCardNumberLabel,
        name: "encryptedCardNumber"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("div", {
              class: "gfu-field__input",
              "data-cse": "encryptedCardNumber"
            }, null, -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.cardBrandItems, ({
                                    brand,
                                    brandImageUrl,
                                    classes
                                }) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: brand,
                  class: _normalizeClass(classes),
                  type: "button",
                  onClick: $event => ($options.onBrandButtonClick(brand))
                }, [
                  _createVNode(_component_base_image, {
                    width: "34",
                    src: brandImageUrl,
                    alt: brand,
                    "data-qa": `card-brand:${brand}`
                  }, null, 8 /* PROPS */, ["src", "alt", "data-qa"])
                ], 10 /* CLASS, PROPS */, _hoisted_6))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["display-name"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_field, {
            "display-name": _ctx.Resources.Checkout.CheckoutCreditCardExpiryDateLabel,
            name: "encryptedExpiryDate",
            "data-qa": "adyen-form:ExpiryDate"
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createElementVNode("div", {
                class: "gfu-field__input",
                "data-cse": "encryptedExpiryDate"
              }, null, -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["display-name"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_field, {
            "display-name": _ctx.Resources.Checkout.CheckoutCreditCardSecurityLabel,
            name: "encryptedSecurityCode"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createElementVNode("div", {
                class: "gfu-field__input",
                "data-cse": "encryptedSecurityCode"
              }, null, -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["display-name"])
        ])
      ])
    ]),
    ($props.isSaveCardCheckboxVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_checkbox_field, {
                modelValue: $data.isCardSaved,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.isCardSaved) = $event)),
                class: "_mt-3",
                condensed: true,
                "display-name": _ctx.Resources.Checkout.CheckboxSaveCardMessage,
                name: "storeCreditCard",
                "label-class": "_flex",
                "data-qa": "crowdfunding-save-card"
              }, null, 8 /* PROPS */, ["modelValue", "display-name"])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}